import React from "react";
import { Text } from "@foris/avocado-suite";
import { useTranslation } from "react-i18next";
import Modal from "@components/modal";

interface DuplicatedStructureModalProps {
  isOpen?: boolean;
  onClose: () => void;
}

const DuplicatedStructureModal = ({ isOpen, onClose }: DuplicatedStructureModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      typeState="error"
      show={isOpen}
      title={t("programming-structures.modals.code-subject-already-exists.title")}
      textButtonPrincipal={t("generals.ok")}
      colorButtonPrincipal="danger"
      onClose={onClose}
      onClickPrincipal={onClose}
    >
      <Text>{t("programming-structures.modals.code-subject-already-exists.description")}</Text>
    </Modal>
  );
};

export default DuplicatedStructureModal;
